/** Time zone names and the US zones practices pick from (Settings → Practice & Locations, review texts). */

/** "Pacific Time" (long) or "PT" (short) for an IANA zone; the zone id itself if unknown. */
export function timeZoneName(timezone: string, style: 'long' | 'short' = 'long'): string {
  try {
    const opts: Intl.DateTimeFormatOptions = {
      timeZone: timezone,
      timeZoneName: style === 'long' ? 'longGeneric' : 'shortGeneric',
    };
    const part = new Intl.DateTimeFormat('en-US', opts)
      .formatToParts(new Date())
      .find((p) => p.type === 'timeZoneName');
    return part?.value ?? timezone;
  } catch {
    return timezone;
  }
}

/** US practice zones offered wherever a practice picks one; the current value is kept even when it is not listed. */
export const PRACTICE_TIME_ZONES: readonly string[] = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
];
